import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';
import { PaginationProps } from '../types';

export type UsaStateListData = AnyObject

export type UsaStateListResponse = UsaStateListData
export type UsaStateListColumns = 'id' | 'name' | 'code' | 'zipPrefix' | 'createdAt' | 'updatedAt';

export type UsaStateListGetParams = PaginationProps<UsaStateListColumns> & {
  search?: string;
  countryId?: number;
}

export const usaStateList = (payload: UsaStateListGetParams): Action<UsaStateListGetParams> => ({
  type: actions.usaStateListTrigger.toString(),
  payload,
});

export const usaStateListClear = (): Action => ({
  type: actions.usaStateListClear.toString(),
});

export const usaStateListErrorClear = (): Action => ({
  type: actions.usaStateListErrorReset.toString(),
});

export function* usaStateListRequestSaga({ payload }: Action<UsaStateListGetParams>) {
  yield put({
    type: actions.usaStateListStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.usaStateListError.toString(),
      payload: {
        message: 'UsaStateList: Parameters not passed.',
      },
    });

    return;
  }

  const params = new URLSearchParams(Object.entries(payload).filter((entry) => !!entry[1]));

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/usa-states?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<UsaStateListData, UsaStateListResponse>(
    response,
    actions.usaStateListSuccess.toString(),
    actions.usaStateListError.toString(),
    false,
    (usaStateListData) => usaStateListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.usaStateListTrigger.toString(),
    defaultProcessingSaga(
      usaStateListRequestSaga,
      {
        error: actions.usaStateListError.toString(),
        locationCancel: actions.usaStateListClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.usaStateListSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.usaStateListError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.usaStateListErrorReset.toString(),
    });
  });
}
